<template>
	<div style="margin-top:16px">
		<div v-show="question.type !== 4" class="answer big">
			<!-- <span class="mr40" :class="{ green: question.row === 1, red: question.row !== 1 }" v-show="question.type !== 4">{{ question.row === 1 ? '回答正确' : '回答错误' }}</span> -->
			<!-- <span  class="text_anawer" >正确答案：{{question.answer}}</span> -->
			<!-- <span v-if="question.type == 3">正确答案：{{question.answer == 1?'正确':'错误'}}</span> -->
			<!-- <span v-else-if="question.answer">正确答案：{{question.answer.split('').sort().join('')}}</span> -->
			<div class="rightAnswers">
				<img src="@/assets/images/homeWork/rightAnswers.png" alt="">
				<div class="rightAnswers-cont">
					正确答案：
					<span v-if="question.type == 3" class="defaultColor">{{question.answer == 1?'正确':'错误'}}</span>
					<span v-else class="defaultColor">{{ grtSortData(question.answer) }}</span>
				</div>
			</div>
			<div class="youAnswers">
				你的答案：
				<template v-if="question.type !== 3">
					<span :class="grtSortData(question.answer) == grtSortData(question.user_answer) ? 'successColor' : 'failColor'"> {{ grtSortData(question.user_answer) }} </span>
				</template>
				<template v-else>
					<span :class="grtSortData(question.answer) == grtSortData(question.user_answer) ? 'successColor' : 'failColor'">{{question.user_answer == 1?'正确':'错误'}}</span>
				</template>
			</div>
		</div>
		<div class="parse">
			<div class="rightAnswers marginBottom16 paddingtop8" v-show="question.type === 4">
				<img src="@/assets/images/homeWork/rightAnswers.png" alt="">
				<div class="rightAnswers-cont font600 ">
					本题得分：{{ modeType == 1 ? (question.user_score == 0 || question.user_score > 0 ? question.user_score : '暂无') : '暂无成绩' }}
				</div>
			</div>
			<div class="parse-tit flex flex-middle big">
				题目解析
			</div>
			<div class="parse-cont whitespace-pre">{{ question.analysis?question.analysis:'暂无解析' }}</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return{
			optionTxtList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
		}
	},
	props: {
		indexanawer: {
			type: String,
			default: ''
		},
		question: {
			type: Object,
			default: () => {}
		},
		comment:{
			type:String,
			default:''
		},
		cur:{
			type:Number,
			default:()=>{return 0}
		},
		total:{
			type:Number,
			default:()=>{return 0}
		},
		modeType: {
			type: Number,
			default: ()=>{return 1}
		}
	},
	methods: {
		grtSortData(data) {
			if (data) {
				return data.split('').sort().join('')
			}
			return 0
        },
		copy() {
			
		}
	}
};
</script>

<style lang="scss" scoped>
@import url('../../../../css/flex.scss');
	.text_anawer{
		// display: flex;
		width: 100%;
		word-break: break-all;
	}
.answer {
	font-size: 16px;
	color: #202020;
	font-weight: 600;
	display: flex;
	justify-content: space-between;
	.mr40 {
		margin-right: 20px;
	}
	.green {
		color: #0bb65d;
	}
	.red {
		color: #f34718;
	}
}
.parse {
	margin-top: 16px;
	font-size: 16px;
	border-top: 1px solid #F0F4F5;
	padding-top: 8px;
	img {
		width: 22px;
		height: 16px;
	}
	&-tit {
		color: #202020;
		> span {
			width: 4px;
			height: 16px;
			background: #10A675;
			border-radius: 2px;
			margin-right: 10px;
		}
	}
	&-cont {
		color: #848586;
		background-color: #fff;
		box-sizing: border-box;
		margin-top: 8px;
		font-size: 14px;
		text-align: justify;
		line-height: 1.6em;
	}
	.refer {
		color: #888;
		padding-top: 14px;
		.link {
			color: #0c7fff;
			background-color: rgba(12, 127, 255, 0.1);
			padding: 1px 3px;
			margin-left: 4px;
			word-break: break-all;
		}
	}
}
.rightAnswers {
	align-items: center;
	display: flex;
	img {
		width: 22px;
		height: 16px;
	}
	.rightAnswers-cont {
		margin-left: 8px;
	}
}
.paddingtop8 {
	padding-top: 8px;
}
.font600 {
	font-weight: 600;
}
.marginBottom16 {
	margin-bottom: 16px;
}
.defaultColor {
	color: #286BFF;
}
.successColor {
	color: #10B881;
}
.failColor {
	color: #FF8982;
}
.whitespace-pre {
	white-space: pre-wrap;
}
</style>
